import { NgModule } from '@angular/core';
import { JourneyPlannerModule } from './journey-planner';
import { BannersModule } from './banners';

import { CoreModule } from '@ridango/core';

import { AccountTicketsModule } from './account-tickets';
import { ApplicationModule } from './application';
import { AreasModule } from './areas/areas.module';
import { AuthModule } from './auth';
import { BankcardTicketsModule } from './bankcard-tickets';
import { CardGroupModule } from './card-group/card-group.module';
import { CardInfoModule } from './card-info/card-info.module';
import { CardModule } from './card/card.module';
import { CompanyNgrxModule } from './company-ngrx/company.module';
import { CompanyModule } from './company/company.module';
import { ComponentsComponent } from './components.component';
import { CoreUiModule } from './core-ui/core-ui.module';
import { CustomerModule } from './customer/customer.module';
import { IntercityModule } from './intercity/intercity.module';
import { MediumModule } from './medium/medium.module';
import { MyTicketsModule } from './my-tickets/my-tickets.module';
import { NotificationsModule } from './notifications/notifications.module';
import { OauthAccountModule } from './oauth-account/oauth-account.module';
import { PaymentMethodsModule } from './payment-methods/payment-methods.module';
import { PersonalizeModule } from './personalize/personalize.module';
import { PowerUserModule } from './power-user/power-user.module';
import { ProductCategoriesModule } from './product-categories/product-categories.module';
import { ProductsSelectorModule } from './products-selector/products-selector.module';
import { ProductsModule } from './products/products.module';
import { PurchaseHistoryModule } from './purchase-history/purchase-history.module';
import { PurchaseModule } from './purchase/purchase.module';
import { RealtimeModule } from './realtime/realtime.module';
import { ReceiptModule } from './receipt/receipt.module';
import { RefundModule } from './refund/refund.module';
import { RelatedCardModule } from './related-card/related-card.module';
import { RideBookingsModule } from './ride-bookings/ride-bookings.module';
import { RideHistoryModule } from './ride-history/ride-history.module';
import { RidePlannerModule } from './ride-planner/ride-planner.module';
import { ScheduleModule } from './schedule/schedule.module';
import { ShoppingCartModule } from './shopping-cart/shopping-cart.module';
import { StopsModule } from './stops/stops.module';
import { SubscriptionModule } from './subscription/subscription.module';
import { SwishModule } from './swish/swish.module';
import { TicketsModule } from './tickets/tickets.module';
import { TravellerModule } from './traveller/traveller.module';
import { ValidationHistoryModule } from './validation-history/validation-history.module';
import { OpenTripPlannerModule } from './open-trip-planner';
import { FirebaseModule } from './firebase';
import { CorporateEmployeesModule } from './corporate-employees/corporate-employees.module';
import { CustomerAccountsModule } from './customer-accounts/customer-accounts.module';
import { FavoritesModule } from './favorites';
import { TicketHistoryModule } from './ticket-history/ticket-history.module';
import { EffectsModule } from '@ngrx/effects';
import { PermissionsModule } from './permissions';
import { StoreModule } from '@ngrx/store';
import { OrganizationsModule } from './organizations/organizations.module';
import { OrganizationPartsModule } from './organization-parts/organization-parts.module';
import { DateTimePickerModule } from './datetime-picker/datetime-picker.module';
@NgModule({
    imports: [
        CoreModule,
        CoreUiModule,
        StopsModule,
        ProductsModule,
        TravellerModule,
        TicketsModule,
        NotificationsModule,
        ShoppingCartModule,
        PaymentMethodsModule,
        ReceiptModule,
        MyTicketsModule,
        OauthAccountModule,
        PurchaseHistoryModule,
        CustomerModule,
        SwishModule,
        RelatedCardModule,
        PowerUserModule,
        AreasModule,
        CardGroupModule,
        CompanyModule,
        ProductCategoriesModule,
        MediumModule,
        RefundModule,
        CardModule,
        CardInfoModule,
        RealtimeModule,
        IntercityModule,
        SubscriptionModule,
        AuthModule,
        AccountTicketsModule,
        PurchaseModule,
        ApplicationModule,
        ValidationHistoryModule,
        RideHistoryModule,
        RideBookingsModule,
        ScheduleModule,
        RidePlannerModule,
        BankcardTicketsModule,
        PersonalizeModule,
        JourneyPlannerModule,
        BannersModule,
        ProductsSelectorModule,
        CompanyNgrxModule,
        TicketHistoryModule,
        EffectsModule.forRoot([]),
        StoreModule.forRoot([]),
        OpenTripPlannerModule,
        CorporateEmployeesModule,
        CustomerAccountsModule,
        PermissionsModule,
        FavoritesModule,
        OrganizationsModule,
        OrganizationPartsModule,
        DateTimePickerModule
    ],
    providers: [],
    declarations: [ComponentsComponent],
    exports: [
        CoreUiModule,
        StopsModule,
        ProductsModule,
        TravellerModule,
        TicketsModule,
        NotificationsModule,
        ShoppingCartModule,
        PaymentMethodsModule,
        ReceiptModule,
        MyTicketsModule,
        OauthAccountModule,
        PurchaseHistoryModule,
        CustomerModule,
        SwishModule,
        RelatedCardModule,
        PowerUserModule,
        AreasModule,
        CardGroupModule,
        CompanyModule,
        ProductCategoriesModule,
        MediumModule,
        RefundModule,
        CardModule,
        CardInfoModule,
        RealtimeModule,
        IntercityModule,
        SubscriptionModule,
        AuthModule,
        AccountTicketsModule,
        PurchaseModule,
        ApplicationModule,
        ValidationHistoryModule,
        RideHistoryModule,
        RideBookingsModule,
        BankcardTicketsModule,
        PersonalizeModule,
        ProductsSelectorModule,
        CompanyNgrxModule,
        TicketHistoryModule,
        BannersModule,
        JourneyPlannerModule,
        OpenTripPlannerModule,
        FirebaseModule,
        FavoritesModule,
        FirebaseModule,
        PermissionsModule,
        CorporateEmployeesModule,
        CustomerAccountsModule,
        OrganizationsModule,
        OrganizationPartsModule,
        DateTimePickerModule
    ]
})
export class ComponentsModule {}
// https://github.com/ReactiveX/rxjs/blob/master/docs_apps/movingo/src/app/content/guide/v6/migration.md
